/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderOrigin } from './OrderOrigin';
import {
    OrderOriginFromJSON,
    OrderOriginFromJSONTyped,
    OrderOriginToJSON,
    OrderOriginToJSONTyped,
} from './OrderOrigin';
import type { OrderType } from './OrderType';
import {
    OrderTypeFromJSON,
    OrderTypeFromJSONTyped,
    OrderTypeToJSON,
    OrderTypeToJSONTyped,
} from './OrderType';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
    AddressToJSONTyped,
} from './Address';
import type { HeoCustomerOrderNumber } from './HeoCustomerOrderNumber';
import {
    HeoCustomerOrderNumberFromJSON,
    HeoCustomerOrderNumberFromJSONTyped,
    HeoCustomerOrderNumberToJSON,
    HeoCustomerOrderNumberToJSONTyped,
} from './HeoCustomerOrderNumber';

/**
 * 
 * @export
 * @interface CustomerOrderDetails
 */
export interface CustomerOrderDetails {
    /**
     * 
     * @type {string}
     * @memberof CustomerOrderDetails
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof CustomerOrderDetails
     */
    createdAt: Date;
    /**
     * 
     * @type {HeoCustomerOrderNumber}
     * @memberof CustomerOrderDetails
     */
    orderNumber: HeoCustomerOrderNumber;
    /**
     * 
     * @type {OrderType}
     * @memberof CustomerOrderDetails
     */
    orderType?: OrderType;
    /**
     * 
     * @type {OrderOrigin}
     * @memberof CustomerOrderDetails
     */
    orderOrigin?: OrderOrigin;
    /**
     * 
     * @type {number}
     * @memberof CustomerOrderDetails
     */
    totalAmount: number;
    /**
     * 
     * @type {string}
     * @memberof CustomerOrderDetails
     */
    customerReference: string;
    /**
     * 
     * @type {Address}
     * @memberof CustomerOrderDetails
     */
    shippingAddress?: Address;
}



/**
 * Check if a given object implements the CustomerOrderDetails interface.
 */
export function instanceOfCustomerOrderDetails(value: object): value is CustomerOrderDetails {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('orderNumber' in value) || value['orderNumber'] === undefined) return false;
    if (!('totalAmount' in value) || value['totalAmount'] === undefined) return false;
    if (!('customerReference' in value) || value['customerReference'] === undefined) return false;
    return true;
}

export function CustomerOrderDetailsFromJSON(json: any): CustomerOrderDetails {
    return CustomerOrderDetailsFromJSONTyped(json, false);
}

export function CustomerOrderDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomerOrderDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': (new Date(json['createdAt'])),
        'orderNumber': HeoCustomerOrderNumberFromJSON(json['orderNumber']),
        'orderType': json['orderType'] == null ? undefined : OrderTypeFromJSON(json['orderType']),
        'orderOrigin': json['orderOrigin'] == null ? undefined : OrderOriginFromJSON(json['orderOrigin']),
        'totalAmount': json['totalAmount'],
        'customerReference': json['customerReference'],
        'shippingAddress': json['shippingAddress'] == null ? undefined : AddressFromJSON(json['shippingAddress']),
    };
}

export function CustomerOrderDetailsToJSON(json: any): CustomerOrderDetails {
    return CustomerOrderDetailsToJSONTyped(json, false);
}

export function CustomerOrderDetailsToJSONTyped(value?: CustomerOrderDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'].toISOString(),
        'orderNumber': HeoCustomerOrderNumberToJSON(value['orderNumber']),
        'orderType': OrderTypeToJSON(value['orderType']),
        'orderOrigin': OrderOriginToJSON(value['orderOrigin']),
        'totalAmount': value['totalAmount'],
        'customerReference': value['customerReference'],
        'shippingAddress': AddressToJSON(value['shippingAddress']),
    };
}

